class Transformation {
  constructor({ type, validator, formatter }) {
    this.type = type;
    this.validator = validator;
    this.formatter = formatter;
  }

  static returnErrorIfInvalid(isValid, error) {
    return isValid ? undefined : error;
  }

  static get prefixMap() {
    return {
      width: 'w_',
      height: 'h_',
      format: 'f_',
      quality: 'q_',
      devicePixelRatio: 'dpr_',
      backgroundColor: 'b_rgb:',
      transformation: 'fl_',
      startOffset: 'so_',
      overlay: 'l_',
    };
  }

  get prefix() {
    return Transformation.prefixMap[this.type];
  }

  validate(value) {
    if (!this.prefix) {
      return `utils:Cloudinary:Transformation - transformation:${this.type} is not supported.`;
    }

    return this.validator(value);
  }

  format(value) {
    return this.formatter ? this.formatter(value) : `${this.prefix}${value}`;
  }
}

export default Transformation;
